export const arrowMotion = {
  expanded: { rotate: -180 },
  notExpanded: { rotate: 0 },
};

export const iconSize = 12;
